export const getImagePath = (imageKey: string): string => {
    const imageMap: { [key: string]: string } = {
        'losAngeles': '/homepage/homepage-office-locations-los-angeles.jpg',
        'newYork': '/homepage/homepage-office-locations-new-york.jpg',
        'savannah': '/homepage/homepage-office-locations-savannah.jpg',
        'houston': '/homepage/homepage-office-locations-houston.jpg',
        'seattle': '/homepage/homepage-office-locations-seattle.jpg',
        'norfolk': '/homepage/homepage-office-locations-norfolk.jpg',
    };
    return imageMap[imageKey] || imageMap.losAngeles;
};
